import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MetaService } from '../../services/metaService';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-deep-link',
  standalone: false,
  templateUrl: './deep-link.component.html',
  styleUrl: './deep-link.component.scss',
})
export class DeepLinkComponent implements OnInit {
  challengeId: string | null = null;
  challengeTitle: string = ''; // Variable to store challenge title
  loading: boolean = true; // Loading state
  dynamicLink: string = '';

  constructor(
    private route: ActivatedRoute,
    private metaService: MetaService,
    // private firestoreService: FirestoreService,
  ) {}

  ngOnInit(): void {
    // Subscribe to queryParams to get challengeId and challengeTitle
    this.route.queryParams.subscribe((params) => {
      this.challengeId = params['challengeId'] || null;
      this.challengeTitle = params['ts'] || '';

      if (this.challengeId && !this.isInAppBrowser()) {
        const deepLink = this.buildNativeDeepLink();
        if (deepLink) {
          setTimeout(() => {
            window.location.href = deepLink;
          }, 300);
        }
      }

      // TODO DELETE när firebase dynamic links är bortrensat
        // Generate dynamic link
        // this.dynamicLinkService
        //   .generateDynamicLink(this.challengeId)
        //   .subscribe((response: any) => {
        //     setTimeout(() => {
        //       this.dynamicLink = response.shortLink; // The generated dynamic link
        //     }, 1000); // 1 second delay (adjust as needed)
        //   });
    });

    // Set meta tags outside the queryParams subscription as it's not dependent on challengeId
    this.metaService.setMetaTags(
      'Join my Versus challenge!',
      'Challenge your friends and see who comes out on top!',
      'assets/inviteImage.png',
      'https://' + environment.dynamicLink.domainUriPrefix + '/joinChallenge'
    );
  }

  openInApp(): void {
    const deepLink = this.buildNativeDeepLink();
    if (!deepLink) return;

    const start = Date.now();
    window.location.href = deepLink;

    // Store fallback
    setTimeout(() => {
      if (Date.now() - start < 2000) {
        if (this.isIos()) {
          window.location.href = "https://apps.apple.com/us/app/versus-fitness-challenges/id6740733976";
        } else if (this.isAndroid()) {
          window.location.href =
            'https://play.google.com/store/apps/details?id=com.yourcompany.versus';
        }
      }
    }, 1500);
  }

  buildNativeDeepLink(): string {
    if (!this.challengeId) return '';

    const params = new URLSearchParams({
      challengeId: this.challengeId,
    }).toString();

    if (this.isIos()) {
      // Denna länk motsvarar: versus://versus-studios.com/joinChallenge?challengeId=123
      // Uppdelad i scheme (versus), host (versus-studios.com) och path (/joinChallenge)
      // I info.plist har jag lagt till versus som en CFBundleURLSchemes
      // Borde? funka
      return `${environment.dynamicLink.iosAppUrlScheme}://${environment.dynamicLink.domainUriPrefix}/joinChallenge?${params}`;
    }

    if (this.isAndroid()) {
      return (
        `versus://${environment.dynamicLink.domainUriPrefix}/joinChallenge?${params}`
      );
    }

    return '';
  }

  isIos(): boolean {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
  }

  isAndroid(): boolean {
    return /Android/.test(navigator.userAgent);
  }

  isInAppBrowser(): boolean {
    const ua = navigator.userAgent || navigator.vendor;
    return (
      ua.includes('Snapchat') ||
      ua.includes('Instagram') ||
      ua.includes('FBAN') ||
      ua.includes('FBAV') ||
      ua.includes('LinkedIn')
    );
  }

  // Method to fetch challenge data based on challengeId
  // OBS Put on hold until we figure out how to grant this website permissions
  // fetchChallengeData(challengeId: string): void {
  //   console.log('fetch challenge data');
  //   this.firestoreService
  //     .getChallengeData(challengeId)
  //     .then((docSnapshot: any) => {
  //       console.log(docSnapshot);

  //       if (docSnapshot.exists()) {
  //         const data = docSnapshot.data();
  //         console.log('test ' + data);
  //         this.challengeTitle = data['title'] || 'Challenge not found'; // Set challenge title to the variable
  //       } else {
  //         this.challengeTitle = 'Challenge not found'; // If the document doesn't exist
  //       }
  //       this.loading = false; // Set loading to false once the data is fetched
  //     })
  //     .catch((error: any) => {
  //       console.error('Error fetching challenge data:', error);
  //       this.challengeTitle = 'Error fetching challenge data';
  //       this.loading = false; // Set loading to false on error
  //     });
  // }
}
